import React from 'react'
import styled, { css } from 'styled-components'

import i18n from 'live/services/i18n'

const ListDetails = ({ name, type, toInfo, data, handlerClick }) => {
    const [showList, setShowList] = React.useState(false)
    const [idx, setIdx] = React.useState<undefined | number>(undefined)
    const info = {
        colorBar: { threats: '#7BC3EB', consequences: '#F58383' }
    }

    const hasdegraded = data && data?.b?.map((e, i) => e?.barriers?.filter((k, j) => k?.degraded)?.length)

    return (
        <ListDetailsContainer
            className="ListDetails"
            idx={idx}
            showList={showList}
            colorBar={info.colorBar[type?.toLowerCase()]}
        >
            <header className="ListDetails_header">
                <h4 className="ListDetails_header-title">{i18n(type)}</h4>
            </header>
            <ul>
                {data &&
                    data?.a?.map((e, i) => {
                        return (
                            <li
                                className={`ListItem_inner__${i}`}
                                key={i}
                                onClick={ev => {
                                    ev.stopPropagation()
                                    setIdx(i)
                                    setShowList(!showList)
                                    handlerClick(ev, i, e?.children?.length * 2)
                                }}
                            >
                                <div className="ListItem_inner">
                                    <i
                                        className={`fas fa-caret-down ${i == idx && showList ? 'arrow-rotate' : ''}`}
                                    ></i>
                                    <div
                                        className={`ListItem_circle-marker ${
                                            hasdegraded[i] ? 'circle-marker-degraded' : ''
                                        }`}
                                    />
                                    <div className="ListItem_content">
                                        <span className="Content_title">{e?.description}</span>
                                        <small>
                                            {i18n('Frequency')}
                                            <span className="Bowtie_value_bold">
                                                {data?.b[i]?.currentFrequency?.toExponential(2)}
                                                {/* 10<sup> -11</sup> */}
                                            </span>
                                            <span className="Bowtie_pipe">|</span>
                                            <span>{hasdegraded[i]}</span>/{e?.children?.length}{' '}
                                            {i18n('degraded barriers')}
                                        </small>
                                    </div>
                                </div>
                                <ul
                                    className={`ListItem_inner-list ${idx == i && showList ? 'inner-list-expand' : ''}`}
                                >
                                    {e?.children &&
                                        e?.children?.length &&
                                        e?.children?.map((k, j) => {
                                            return (
                                                <li
                                                    key={`ListItem_inner-list-${i}`}
                                                    onClick={ev => {
                                                        ev.stopPropagation()
                                                        toInfo(ev, {
                                                            a: k,
                                                            b: data?.b[i]?.barriers[j],
                                                            type: type,
                                                            name: name
                                                        })
                                                    }}
                                                    className={`ListItem_inner-list_item ${
                                                        data?.b[i]?.barriers[j]?.degraded ? 'inner-item-degraded' : ''
                                                    }`}
                                                >
                                                    <span>{k?.description}</span>
                                                    <button>
                                                        <i className="far fa-chevron-right"></i>
                                                    </button>
                                                </li>
                                            )
                                        })}
                                </ul>
                            </li>
                        )
                    })}
            </ul>
        </ListDetailsContainer>
    )
}

export default ListDetails

const ListDetailsContainer = styled.section<{ idx: undefined | number; showList: boolean; colorBar: string }>`
    border-left: 4px solid ${props => props.colorBar};
    padding-left: 14px;
    margin-bottom: 24px;
    width: inherit;
    .ListDetails_header {
    }
    .ListDetails_header-title {
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: #364159;
        text-transform: uppercase;
    }

    ul,
    .ListItem_content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    ul li {
        &:not(:last-child) {
            margin-bottom: 20px;
        }
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }
    ul li .ListItem_inner {
        display: flex;
        align-items: flex-start;
        i {
            transition: 0.3s all ease-in-out;
            color: #37a3ef;
        }
        .arrow-rotate {
            transform: rotate(180deg);
        }
        i,
        .ListItem_circle-marker {
            margin-right: 8px;
        }

        .ListItem_circle-marker {
            width: 8px;
            height: 8px;
            margin-top: 4px;
            padding: 4px;
            border-radius: 100%;
            background: #01c292;
        }

        .circle-marker-degraded {
            background: #c43535;
        }

        .ListItem_content {
            width: 100%;

            .Content_title {
                font-style: normal;
                font-weight: 600;
                font-size: 10px;
                line-height: 16px;
                display: flex;
                align-items: center;
                text-transform: uppercase;
                color: #364159;
            }
            small {
                font-style: normal;
                font-weight: normal;
                font-size: 11px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #364159;
            }
        }
    }

    ul li .ListItem_inner-list {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transition: 0.3s all ease-in-out;

        height: 0px;
        opacity: 0;
        margin-top: 0px;

        &.inner-list-expand {
            height: auto;
            opacity: 1;
            margin-top: 16px;
        }

        .ListItem_inner-list_item {
            position: relative;
            text-transform: uppercase;
            font-style: normal;
            font-weight: normal;
            font-size: 11px;
            line-height: 16px;
            color: #364159;
            padding-left: 32px;
            display: flex;
            flex-direction: row;
            /* border: 1px solid #000; */
        }
        .ListItem_inner-list_item button {
            width: 32px;
            cursor: pointer;
            margin: 0;
            padding: 0;
            appearance: none;
            border: none;
            outline: none;
            background: none;
            font-style: normal;
            font-weight: normal;
            display: inline-block;

            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 16px;
            color: #37a3ef;
        }
        .ListItem_inner-list_item span {
            /* border: 1px solid #000; */

            width: 85%;
            display: inline-block;
            /* width: 180px; */
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
        }

        .ListItem_inner-list_item::before {
            content: '';
            position: absolute;
            top: 0;
            left: 16px;
            width: 8px;
            height: 8px;
            padding: 4px;
            border-radius: 100%;
            z-index: 1;
            background: #01c292;
        }
        .ListItem_inner-list_item.inner-item-degraded::before {
            background: #c43535;
        }
        .ListItem_inner-list_item:not(:last-child)::after {
            content: '';
            position: absolute;
            top: 0;
            left: 19.3px;
            background: #bac0cb;
            width: 1px;
            height: calc(100% + 24px);
        }
    }
`
